"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var I18n = require("i18n-js");
var elog = require("@reverbdotcom/commons/dist/elog");
var form_group_1 = require("@reverbdotcom/commons/dist/components/form_group");
var tokenized_field_1 = require("./tokenized_field");
var adyen_secured_fields_1 = require("./adyen_secured_fields");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var ADYEN_CHECKOUT_CONTAINER_ID = 'mount-adyen-cc-form';
exports.ENCRYPTED_CARD_NUMBER_FIELD_NAME = 'encryptedCardNumber';
var COMPONENT_NAME = 'TokenizedCreditCardFields';
var TokenizedCreditCardFields = /** @class */ (function (_super) {
    tslib_1.__extends(TokenizedCreditCardFields, _super);
    function TokenizedCreditCardFields(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            timer: null,
            brand: '',
            adyenConfigFinished: false,
            encryptedCardNumber: {
                hasFocus: false,
                error: '',
            },
            encryptedSecurityCode: {
                hasFocus: false,
                error: '',
            },
            encryptedExpiryDate: {
                hasFocus: false,
                error: '',
            },
        };
        return _this;
    }
    TokenizedCreditCardFields.prototype.onFieldValid = function (data) {
        var _a;
        var tokenizedData = (_a = {},
            _a[data.encryptedFieldName] = data.blob || '',
            _a);
        this.props.onTokenizedFieldUpdate(tokenizedData);
        if (data.encryptedFieldName === exports.ENCRYPTED_CARD_NUMBER_FIELD_NAME) {
            this.props.onCardDataUpdate({ last4: data.endDigits });
        }
    };
    TokenizedCreditCardFields.prototype.onBrand = function (object) {
        this.props.onCardDataUpdate({ cardType: object.brand });
        this.setState({ brand: object.brand });
    };
    TokenizedCreditCardFields.prototype.onFocus = function (data) {
        var _a;
        var fieldState = this.state[data.fieldType];
        var newFieldState = tslib_1.__assign(tslib_1.__assign({}, fieldState), { hasFocus: data.focus });
        var newState = (_a = {},
            _a[data.fieldType] = newFieldState,
            _a);
        this.setState(newState);
    };
    TokenizedCreditCardFields.prototype.onError = function (data) {
        var _a;
        var fieldState = this.state[data.fieldType];
        var errorValue = data.error === '' ? '' : I18n.t("discovery.creditCardForm." + data.fieldType + "Error");
        var newFieldState = tslib_1.__assign(tslib_1.__assign({}, fieldState), { error: errorValue });
        var newState = (_a = {},
            _a[data.fieldType] = newFieldState,
            _a);
        this.setState(newState);
    };
    TokenizedCreditCardFields.prototype.onAdyenConfigSuccess = function () {
        this.setState({ adyenConfigFinished: true });
    };
    TokenizedCreditCardFields.prototype.checkIfConfigFinished = function () {
        if (!this.state.adyenConfigFinished) {
            var message = "Adyen Credit Card form failed to initialize after " + this.props.waitForConfigSuccessSeconds + "s. If this is happening frequently, deactivate rollout: \"adyen_checkout_api_vaulting\"";
            elog.error('adyen_credit_card_form_failed_to_initialize', { message: message, componentName: COMPONENT_NAME }, null);
        }
    };
    TokenizedCreditCardFields.prototype.secondsToMilliseconds = function (seconds) {
        return seconds * 1000;
    };
    TokenizedCreditCardFields.prototype.componentDidMount = function () {
        this.setState({
            timer: setTimeout(this.checkIfConfigFinished, this.secondsToMilliseconds(this.props.waitForConfigSuccessSeconds)),
        });
        adyen_secured_fields_1.mountAdyenSecuredFields({
            domSelector: "#" + ADYEN_CHECKOUT_CONTAINER_ID,
            locale: this.props.user.locale,
            onFieldValid: this.onFieldValid,
            onConfigSuccess: this.onAdyenConfigSuccess,
            onBrand: this.onBrand,
            onFocus: this.onFocus,
            onError: this.onError,
        });
    };
    TokenizedCreditCardFields.prototype.componentWillUnmount = function () {
        if (this.state.timer) {
            clearTimeout(this.state.timer);
        }
    };
    TokenizedCreditCardFields.prototype.renderTokenizedField = function (fieldName) {
        var hasFocus = this.state[fieldName].hasFocus;
        var hasError = this.state[fieldName].error !== '';
        return (React.createElement(tokenized_field_1.default, { fieldName: fieldName, hasFocus: hasFocus, hasError: hasError }));
    };
    TokenizedCreditCardFields.prototype.render = function () {
        return (React.createElement("div", { id: ADYEN_CHECKOUT_CONTAINER_ID },
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-12 scaling-mb-2 pos-relative" },
                    React.createElement("div", { className: "adyen-field__card-icon adyen-field__card-icon--" + this.state.brand }),
                    React.createElement(form_group_1.default, { label: I18n.t('discovery.creditCardForm.cardNumber'), inputName: "encryptedCardNumber", errorText: this.state.encryptedCardNumber.error }, this.renderTokenizedField('encryptedCardNumber')))),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 scaling-mb-2" },
                    React.createElement(form_group_1.default, { label: I18n.t('discovery.creditCardForm.expiration'), inputName: "encryptedExpiryDate", errorText: this.state.encryptedExpiryDate.error }, this.renderTokenizedField('encryptedExpiryDate'))),
                React.createElement("div", { className: "g-col-6 scaling-mb-2" },
                    React.createElement(form_group_1.default, { label: I18n.t('discovery.creditCardForm.cvv'), inputName: "encryptedSecurityCode", errorText: this.state.encryptedSecurityCode.error }, this.renderTokenizedField('encryptedSecurityCode'))))));
    };
    TokenizedCreditCardFields.defaultProps = {
        onCardDataUpdate: function () { },
        waitForConfigSuccessSeconds: 30,
    };
    tslib_1.__decorate([
        bind_1.default
    ], TokenizedCreditCardFields.prototype, "onFieldValid", null);
    tslib_1.__decorate([
        bind_1.default
    ], TokenizedCreditCardFields.prototype, "onBrand", null);
    tslib_1.__decorate([
        bind_1.default
    ], TokenizedCreditCardFields.prototype, "onFocus", null);
    tslib_1.__decorate([
        bind_1.default
    ], TokenizedCreditCardFields.prototype, "onError", null);
    tslib_1.__decorate([
        bind_1.default
    ], TokenizedCreditCardFields.prototype, "onAdyenConfigSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], TokenizedCreditCardFields.prototype, "checkIfConfigFinished", null);
    return TokenizedCreditCardFields;
}(React.Component));
exports.TokenizedCreditCardFields = TokenizedCreditCardFields;
exports.default = user_context_provider_1.withUserContext(TokenizedCreditCardFields);
//# sourceMappingURL=tokenized_credit_card_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/tokenized_credit_card_fields.js
// module id = M5jg
// module chunks = 20 21 22